import wixWindow from 'wix-window';
import wixData from 'wix-data';

$w.onReady(function () {

    let $langugage = wixWindow.multilingual.currentLanguage;
    let filter = wixData.filter();


    if($langugage === "de") { 

        $w("#dataset1").setFilter(wixData.filter()
            .contains("languagekey","de")
            .eq("archived", false)
        );
    }

    if($langugage === "en") {         
        
        $w("#dataset1").setFilter(wixData.filter()
            .contains("languagekey","en")
            .eq("archived", false)
        );
    }
});


export function header1_viewportLeave(event) {
    $w("#header1").style.backgroundColor = "rgba(0,0,0,1.0)";
}